module.exports = __webpack_public_path__ + "dlssrvtline2/img/th-slider-3.jpg?84f2e678";